export default function() {
    return Object.assign({}, ...(Array.from(arguments).filter(Boolean)));
}
